import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { treatmentRecommendationActions } from '../../../../../store';
import { getNoActivePlanMessage } from '../utils';

import type { AppDispatch } from '../../../../../store';
import type { HeaderDialogController, TreatmentPlanV3HeaderState } from './types';

export default function useNoActivePlanAlert(
  dialog: HeaderDialogController,
  state: TreatmentPlanV3HeaderState,
) {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { activeDialog, openDialog, closeDialog } = dialog;
  const {
    treatmentPlan,
    treatmentPlans,
    activeTreatmentPlan,
    tpStatusIdByLabel,
    isPlansLoading,
    selectedClient,
    recommendationTpId,
  } = state;
  const shownAlertKeyRef = useRef('');
  const treatmentPlanId = treatmentPlan?.id;

  const message = getNoActivePlanMessage({
    treatmentPlan,
    treatmentPlans,
    activeTreatmentPlan,
    tpStatusIdByLabel,
    isPlansLoading,
    selectedClient,
  });
  // One alert per plan and message, so closing it does not re-open it on the next render.
  const alertKey = message ? `${treatmentPlanId ?? ''}:${message}` : '';

  useEffect(() => {
    if (!alertKey || activeDialog !== null || shownAlertKeyRef.current === alertKey) return;
    shownAlertKeyRef.current = alertKey;
    openDialog({ kind: 'noActivePlan', message });
  }, [alertKey, activeDialog, message, openDialog]);

  useEffect(() => {
    if (!message && activeDialog?.kind === 'noActivePlan') closeDialog();
  }, [message, activeDialog, closeDialog]);

  useEffect(() => {
    if (treatmentPlanId === undefined || treatmentPlanId === recommendationTpId) return;
    dispatch(
      treatmentRecommendationActions.getRecommendation({
        treatmentPlanId,
        getAccessTokenSilently,
        forceUpdate: true,
      }),
    );
  }, [dispatch, getAccessTokenSilently, treatmentPlanId, recommendationTpId]);
}
